import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateChildFn, Router, RouterStateSnapshot } from "@angular/router";
import { AuthEffects } from "../State/AuthEffects";
import { AuthState } from "../State/AuthState";

export async function authGuard(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<ReturnType<CanActivateChildFn>> {
  const authState = inject(AuthState);
  const authEffects = inject(AuthEffects);
  const router = inject(Router);

  const isAuthenticatedBeforeRestore = authState.isAuthenticated();
  console.info("[AuthGuard] evaluate:start", {
    routeUrl: route.url.map((segment) => segment.path).join("/"),
    routePath: route.routeConfig?.path,
    stateUrl: state.url,
    isAuthenticatedBeforeRestore,
  });

  if (isAuthenticatedBeforeRestore) {
    console.info("[AuthGuard] evaluate:allow_authenticated", {
      isAuthenticatedBeforeRestore,
    });
    return true;
  }

  const restored = await authEffects.restoreSession();
  const isAuthenticatedAfterRestore = authState.isAuthenticated();
  console.info("[AuthGuard] evaluate:restore_result", {
    restored,
    isAuthenticatedAfterRestore,
  });

  if (restored && isAuthenticatedAfterRestore) {
    console.info("[AuthGuard] evaluate:allow_restored", {
      restored,
      isAuthenticatedAfterRestore,
    });
    return true;
  }

  const redirectTree = router.createUrlTree(["/login"]);
  console.warn("[AuthGuard] evaluate:redirect_login", {
    restored,
    isAuthenticatedAfterRestore,
    redirectTo: router.serializeUrl(redirectTree),
  });
  return redirectTree;
}
